<nz-table
  #sortTable
  [nzData]="brokersListCopy"
  nzFrontPagination="false"
  [nzBordered]="true"
  [nzShowPagination]="false"
  [nzScroll]="{ y: tableYScroll + 'px' }"
  class="brokerlist-table"
>
  <thead>
    <tr>
      <th
        class="checkbox-extra-sm"
        [nzShowCheckbox]="true"
        [nzIndeterminate]="
          selectedBrokers.length !== brokersListCopy.length &&
          selectedBrokers.length > 0
        "
        (nzCheckedChange)="onCheckAll($event)"
        [nzChecked]="selectedBrokers.length === brokersListCopy.length"
        nzWidth="30px"
      ></th>
      <th
        *ngIf="showColumns.name"
        nzWidth="{{ showColumns.analyst ? 32 : 60 }}%"
        [nzShowSort]="true"
        (nzSortOrderChange)="onSortChange('name', $event)"
        [nzSortFn]="undefined"
        [(nzSortOrder)]="sortKeys.name"
      >
        Brokers ({{ selectedBrokers.length }})
      </th>
      <th *ngIf="showColumns.analyst" nzWidth="45%">Analyst</th>
      <th
        *ngIf="showColumns.modeldate"
        [nzShowSort]="true"
        (nzSortOrderChange)="onSortChange('modeldatetime', $event)"
        [nzSortFn]="undefined"
        [(nzSortOrder)]="sortKeys.modeldatetime"
      >
        Date
      </th>
    </tr>
  </thead>
  <tbody>
    <tr
      *ngFor="let row of brokersListCopy; index as idx"
      [ngClass]="row.focus ? 'row-disabled' : ''"
      [class.bg-lgrey]="idx % 2 === 1"
    >
      <td
        class="checkbox-extra-sm"
        [nzShowCheckbox]="true"
        [nzChecked]="selectedBrokers.includes(row.sourceid)"
        (nzCheckedChange)="onRowChecked(row.sourceid, $event)"
        [ngClass]="row.focus ? 'disable-checkbox' : ''"
      ></td>
      <td *ngIf="showColumns.name">
        <app-source-name-table-display
          [brokerItem]="row"
          [showCurrentViewInfo]="useFor === UseFor.EXPORT_TO_EXCEL_CC_SELECTION"
          [currentState]="selectedBrokers.includes(row.sourceid)"
          [ccState]="ccState"
          (nameClicked)="onRowChecked($event.id, $event.selected)"
        ></app-source-name-table-display>
      </td>
      <td
        *ngIf="showColumns.analyst"
        nz-tooltip
        nzTooltipTitle="{{ row.analystname }}"
        nzTooltipPlacement="bottomLeft"
        nzTooltipMouseEnterDelay="14"
        [nzTooltipOverlayStyle]="{
          display: row.analystname.length > 19 ? 'inherit' : 'none',
          fontSize: '11px',
          padding: '0px',
          background: '#999'
        }"
      >
        {{ row.analystname | textEllipsis: 19 }}
      </td>
      <td *ngIf="showColumns.modeldate">{{ row.modeldate }}</td>
    </tr>
  </tbody>
</nz-table>
<label
  class="checkbox-showonlycurrent checkbox-sm"
  [ngModel]="localShowOnlyCurrent"
  (ngModelChange)="onShowCurrentSwitch($event); toggleBrokerListRadio.emit()"
  nz-checkbox
  >Show Current Brokers Only
  <va-icon
    size="small"
    name="info-circle"
    class="info-icon"
    nz-tooltip
    nzTooltipTitle="Show only brokers who have sent models post reported earnings."
    [nzTooltipOverlayStyle]="{
      fontSize: '11px',
      padding: '0px',
      background: '#999'
    }"
  >
  </va-icon>
</label>
